export default {_name:'grid.form.section',module:'Card/Form',view:'Element/Section',options:{component:'section',md:12,ms:11,block:{md:11,lg:11,xl:11}}}